import { render } from "./AdminList.vue?vue&type=template&id=c0bc64e6&scoped=true"
import script from "./AdminList.vue?vue&type=script&lang=js"
export * from "./AdminList.vue?vue&type=script&lang=js"

import "./AdminList.vue?vue&type=style&index=0&id=c0bc64e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0bc64e6"]])

export default __exports__